import React, { useCallback } from 'react';
import { useDropzone, Accept, FileRejection } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { POSIconButton } from '@publicisgroupe/p-os-components';

import './Dropzone.less';

interface DropzoneProps {
  acceptedFileTypes: Accept;
  maxFileSize: number;
  getUploadedFiles(uploadedFiles: File[]): void;
  getRejectedFiles(rejectedFiles: FileRejection[]): void;
}

export const Dropzone = ({
  acceptedFileTypes,
  maxFileSize,
  getUploadedFiles,
  getRejectedFiles,
}: DropzoneProps) => {
  const { t } = useTranslation();

  const onDrop = useCallback(
    (accepted: File[], rejectedFiles: FileRejection[]) => {
      getUploadedFiles(accepted);
      getRejectedFiles(rejectedFiles);
    },
    [getRejectedFiles, getUploadedFiles]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: acceptedFileTypes,
    maxSize: maxFileSize,
    multiple: false,
    onDrop,
  });

  return (
    <div
      {...getRootProps()}
      data-testid="file-dropzone"
      className={`file-dropzone dropzone ${isDragActive ? 'active' : ''}`}
    >
      <input {...getInputProps()} data-testid="file-input" className="file-input" />
      <POSIconButton icon="upload" secondary inverted type="button">
        {t('DropzoneButtonUploadFiles')}
      </POSIconButton>
    </div>
  );
};
